<template>
  <Aside />
  <Header />
  <main id="main" class="main">
    <router-view />
  </main>
  <Footer />
</template>

<script setup>
import Aside from '@/components/layouts/Aside.vue'
import Header from '@/components/layouts/Header.vue'
import Footer from '@/components/layouts/Footer.vue'
</script>
